// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notif-users-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .45);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
}

.notif-users-modal {
    width: 420px;
    max-width: 95%;
    max-height: 80vh;
    overflow: auto;
    background: white;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, .2);
}

.notif-users-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 20px;
}

.notif-user-item {
    display: flex;
    align-items: center;
    gap: 14px;
    text-decoration: none;
    color: #111;
    padding: 10px;
    border-radius: 16px;
}

.notif-user-item:hover {
    background: #f5f7fb;
}

.notif-user-item img {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    object-fit: cover;
}

.notif-user-item span {
    display: block;
    color: #666;
    font-size: 13px;
    margin-top: 4px;
}


.notif-user-skeleton {
    display: flex;
    gap: 14px;
    align-items: center;
    padding: 10px;
}

.nus-avatar {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    flex-shrink: 0;
}

.nus-content {
    flex: 1 1;
}

.nus-line {
    width: 100%;
    height: 14px;
    border-radius: 20px;
    margin-bottom: 10px;
}

.nus-line.short {
    width: 45%;
}`, "",{"version":3,"sources":["webpack://./src/componentsL/NotificationUsersModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd","sourcesContent":[".notif-users-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, .45);\n    backdrop-filter: blur(8px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 99999;\n}\n\n.notif-users-modal {\n    width: 420px;\n    max-width: 95%;\n    max-height: 80vh;\n    overflow: auto;\n    background: white;\n    border-radius: 24px;\n    padding: 24px;\n    box-shadow: 0 30px 80px rgba(0, 0, 0, .2);\n}\n\n.notif-users-list {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    margin-top: 20px;\n}\n\n.notif-user-item {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    text-decoration: none;\n    color: #111;\n    padding: 10px;\n    border-radius: 16px;\n}\n\n.notif-user-item:hover {\n    background: #f5f7fb;\n}\n\n.notif-user-item img {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.notif-user-item span {\n    display: block;\n    color: #666;\n    font-size: 13px;\n    margin-top: 4px;\n}\n\n\n.notif-user-skeleton {\n    display: flex;\n    gap: 14px;\n    align-items: center;\n    padding: 10px;\n}\n\n.nus-avatar {\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.nus-content {\n    flex: 1;\n}\n\n.nus-line {\n    width: 100%;\n    height: 14px;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.nus-line.short {\n    width: 45%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
